export default __webpack_public_path__ + "static/media/fill-info.81146f9c.png";